export const roundTwoDigits = (number: number) =>
  number ? Math.floor(number * 100) / 100 : 0;
